<template>
  <BreadCrumb PageTitle="Ajouter Bon de livraison" />
  <AddNote />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "@/components/Common/BreadCrumb.vue";
import AddNote from "@/components/Notes/Delivery/AddNote.vue";

export default defineComponent({
  name: "ListePage",
  components: {
    BreadCrumb,
    AddNote,
  },
});
</script>